import { cx } from 'class-variance-authority';
import { Store } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useI18nContext } from '@/i18n/i18n-react';

interface NotificationPreviewProps {
  title: string;
  body: string;
  iconUrl?: string | null;
  className?: string;
}

export function NotificationPreview({
  title,
  body,
  iconUrl,
  className,
}: NotificationPreviewProps) {
  const { LL } = useI18nContext();
  return (
    <div className={cx('border border-border rounded-2xl p-4', className)}>
      <div className="flex items-start gap-3">
        <Avatar className="size-12 shrink-0 rounded-xl">
          <AvatarImage src={iconUrl ?? undefined} alt="" />
          <AvatarFallback className="rounded-xl bg-sidebar-primary text-sidebar-primary-foreground">
            <Store className="size-6" />
          </AvatarFallback>
        </Avatar>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <p className="font-semibold">
              {title || LL.notificationPreview.titlePlaceholder()}
            </p>
            <p className="text-xs text-muted-foreground">
              {LL.notificationPreview.now()}
            </p>
          </div>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {body || LL.notificationPreview.bodyPlaceholder()}
          </p>
        </div>
      </div>
    </div>
  );
}
